import { InboxApi, MessagingApi } from 'conversations/api'
import { SharedSectionMembership } from 'shared/lib/typings/conversationsSidebar/Filters'
import {
  ConversationSidebarSectionConfig,
  FetchSectionsResponse,
  SectionNotificationSetting,
} from 'shared/src/typings/conversationsSidebar/Filters'
import {
  CreateConvoSidebarSectionConfig,
  UpdateConvoSidebarPayload,
} from 'shared/store/actions/user/sections'

export const fetchSections = async (): Promise<FetchSectionsResponse> =>
  InboxApi.get<FetchSectionsResponse>('/sections/v2').then(({ data }) => data)

export const fetchSharedSections = async (
  url = '/sections/shared'
): Promise<FetchSectionsResponse> =>
  InboxApi.get<FetchSectionsResponse>(url).then(({ data }) => data)

export const fetchSectionMemberships = async (
  sectionId: string
): Promise<SharedSectionMembership[]> =>
  InboxApi.get<SharedSectionMembership[]>(`/sections/v2/${sectionId}/memberships`).then(
    ({ data }) => data
  )

export const createSidebarSection = async (
  section: CreateConvoSidebarSectionConfig
): Promise<ConversationSidebarSectionConfig> => {
  const res = await InboxApi.post('/sections/v2', section)
  return res.data
}

export const updateSidebarSection = async (
  section: UpdateConvoSidebarPayload
): Promise<ConversationSidebarSectionConfig> => {
  const res = await InboxApi.patch(`/sections/v2/${section.id}`, section)
  return res.data
}

interface DeletePayload {
  id: string
  shared: boolean
}
export const deleteSidebarSection = async ({ id, shared }: DeletePayload): Promise<any> => {
  const res = await InboxApi.delete(`/sections/v2/${shared ? 'shared' : 'private'}/${id}`)
  return res.data
}

export const getNotificationsBySection = async (): Promise<
  Record<string, SectionNotificationSetting>
> => {
  const res = await MessagingApi.get('/notifications/settings/subscriptions')
  return res.data.subscriptions
}

export const patchNotificationsBySection = async (
  subscriptions: Record<string, SectionNotificationSetting>
): Promise<void> => {
  const res = await MessagingApi.put('/notifications/settings/subscriptions', { subscriptions })
  return res.data
}
